export default __webpack_public_path__ + "static/media/usman.22c384c5.png";